import React from "react";
import Autocomplete from '@mui/material/Autocomplete';
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import EditIcon from '@mui/icons-material/Edit';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { withStyles } from "@mui/styles";

import { ConfirmCancelDialog } from "../ConfirmCancelDialog";
import { LanguageContext } from '../LanguageContext';

const defaultToolbarStyles = {
    iconButton: {
    },
};

class LocationEdit extends React.Component {
    static contextType = LanguageContext;
    constructor(props) {
        super(props);

        var data = props.Daatta.filter(function (d) {
            return d.locationId === props.rowId;
        });

        this.state = {
            open: false,
            setOpen: false,
            jotainMuuttui: false,
            data: data,
            LocationId: data[0].locationId,
            Name: data[0].name,
            Description: data[0].description,
            Modifier: data[0].modifier,
            StartTime: data[0].startTime,
            EndTime: data[0].endTime
        };

    }

    handleClearData = () => {
        this.setState({
            open: false,
            setOpen: false,
            jotainMuuttui: false,
            LocationId: this.state.data[0].locationId,
            Name: this.state.data[0].name,
            Description: this.state.data[0].description,
            Modifier: this.state.data[0].modifier,
            StartTime: this.state.data[0].startTime,
            EndTime: this.state.data[0].endTime
        });
    }

    handleSave = () => {
        this.props.onEditRow({
            LocationId: this.state.LocationId,
            Name: this.state.Name,
            Description: this.state.Description,
            Modifier: this.state.Modifier,
            StartTime: this.state.StartTime,
            EndTime: this.state.EndTime
        });

        this.handleClearData();
    }

    closeDialog = (list) => {
        var name = 'open' + list;
        this.setState({ [name]: false })
    };

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
            jotainMuuttui: true
        });
    };

    handleClickOpen = () => {
        this.setState({
            open: true,
        });
    }

    handleListChange = (event, newValue, item) => {
        if (newValue != null) {
            this.setState({ [item]: newValue.value })
        }
        else {
            this.setState({ [item]: null })
        }
        this.setState({ jotainMuuttui: true })
    }

    handleClose = () => {
        if (this.state.jotainMuuttui) {
            this.setState({
                setOpen: true
            });
        }
        else {
            this.setState({
                open: false,
                setOpen: false
            });
        }
    }

    handleSetOpenCancel = () => {
        this.setState({
            open: true,
            setOpen: false
        });
    }

    render() {
        const { dictionary } = this.context;
        const { open } = this.state;

        return (
            <React.Fragment>
                <Tooltip title={dictionary.Toolbar.Edit}>
                    <IconButton onClick={this.handleClickOpen}>
                        <EditIcon />
                    </IconButton>
                </Tooltip>

                <Dialog open={open} onClose={this.handleClose}>
                    <DialogTitle>{dictionary.Location.Title}</DialogTitle>
                    <DialogContent style={{ width: "500px" }}>
                        <TextField
                            required
                            margin="dense"
                            label={dictionary.Location.Columns[1]}
                            type="text"
                            fullWidth
                            value={this.state.Name}
                            onChange={this.handleChange('Name')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.Location.Columns[2]}
                            type="text"
                            fullWidth
                            value={this.state.Description}
                            onChange={this.handleChange('Description')}
                        />
                        
                    </DialogContent>
                    <DialogActions
                        style={{ backgroundColor: "#3C495A" }}
                    >
                        <ButtonGroup variant="comboButton">
                            <Button variant="Secondary" onClick={this.handleClose}>
                                {dictionary.Close}
                            </Button>
                            <Button variant="Primary" onClick={this.handleSave}>
                                {dictionary.Save}
                            </Button>
                        </ButtonGroup>
                    </DialogActions>
                </Dialog>
                <ConfirmCancelDialog
                    open={this.state.setOpen}
                    onCancel={this.handleSetOpenCancel}
                    onOk={this.handleClearData}
                />

            </React.Fragment>
        );
    }
}

export default withStyles(defaultToolbarStyles, { name: "LocationEdit" })(LocationEdit);
